import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getAcademyBilledCoursesQuery } from 'modules/academies/graphql/queries';

export default function useBilledCourses() {
  const { data, loading, error } = useQuery(getAcademyBilledCoursesQuery);
  const courses = useMemo(() => data?.billedCourses || [], [data]);

  return {
    courses,
    loading,
    error: getErrorMessage({ error }),
  };
}
